import '@/App.css';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider, useAuth } from './context/AuthContext';
import Header from './components/Header';
import Footer from './components/Footer';
import RouteErrorBoundary from './components/RouteErrorBoundary';
import LandingPage from './pages/LandingPage';
import StoredJobSearchPage from './pages/StoredJobSearchPage';
import CheckFitPage from './pages/CheckFitPage';
import MasterProfileSetupPage from './pages/FindJobsPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import ManageDataPage from './pages/ManageDataPage';
import MyJobsPage from './pages/MyJobsPage';
import DocumentsPage from './pages/DocumentsPage';
import MasterProfilePage from './pages/MasterProfilePage';
import AccountPrivacyPage from './pages/AccountPrivacyPage';
import ApplicationPackagePage from './pages/ApplicationPackagePage';
import EditorPage from './pages/EditorPage';
import AuthPage from './pages/AuthPage';
import RequireAuth from './components/RequireAuth';

function HomeRoute() {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen" data-testid="home-loading" />;
  return user ? <Navigate to="/my-jobs" replace /> : <LandingPage />;
}

function Protected({ children }) {
  return <RequireAuth><RouteErrorBoundary>{children}</RouteErrorBoundary></RequireAuth>;
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <div className="App flex min-h-screen flex-col">
          <BrowserRouter>
            <Header />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<HomeRoute />} />
                <Route path="/find-jobs" element={<RouteErrorBoundary><StoredJobSearchPage /></RouteErrorBoundary>} />
                <Route path="/find-jobs/check-fit" element={<Protected><CheckFitPage /></Protected>} />
                <Route path="/master-profile/setup" element={<Protected><MasterProfileSetupPage /></Protected>} />
                <Route path="/my-jobs" element={<Protected><MyJobsPage /></Protected>} />
                <Route path="/documents" element={<Protected><DocumentsPage /></Protected>} />
                <Route path="/master-profile" element={<Protected><MasterProfilePage /></Protected>} />
                <Route path="/account-privacy" element={<Protected><AccountPrivacyPage /></Protected>} />
                <Route path="/application-package/:jobResultId" element={<Protected><ApplicationPackagePage /></Protected>} />
                <Route path="/job-results/:jobResultId/editor" element={<Protected><EditorPage /></Protected>} />
                <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
                <Route path="/manage-data" element={<Protected><ManageDataPage /></Protected>} />
                <Route path="/dashboard" element={<Navigate to="/my-jobs" replace />} />
                <Route path="/dashboard/jobs" element={<Navigate to="/my-jobs" replace />} />
                <Route path="/dashboard/applications" element={<Navigate to="/my-jobs" replace />} />
                <Route path="/job-results" element={<Navigate to="/my-jobs" replace />} />
                <Route path="/career-agent" element={<Navigate to="/find-jobs" replace />} />
                <Route path="/sign-in" element={<AuthPage />} />
              </Routes>
            </main>
            <Footer />
          </BrowserRouter>
        </div>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
